module.exports = __webpack_public_path__ + "static/media/exclamation.86ecab11.svg";